// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__pcg3Z","addWidgetButton":"Header_addWidgetButton__2N5XO","dashboardTabs":"Header_dashboardTabs__1mSfj","active":"Header_active__1VPn5"};